var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterinline = function SvgTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12S0 18.623 0 12 5.377 0 12 0M9.886 18.382c5.31 0 8.214-4.4 8.214-8.213q.002-.19-.006-.371A5.9 5.9 0 0 0 19.537 8.3a5.9 5.9 0 0 1-1.658.455 2.89 2.89 0 0 0 1.269-1.598 5.9 5.9 0 0 1-1.832.7 2.887 2.887 0 0 0-4.915 2.634 8.19 8.19 0 0 1-5.95-3.017c-.246.425-.39.922-.39 1.449 0 1 .509 1.885 1.287 2.4a2.84 2.84 0 0 1-1.305-.359v.036c0 1.4.994 2.562 2.317 2.832a2.9 2.9 0 0 1-1.305.047 2.88 2.88 0 0 0 2.694 2.006 5.8 5.8 0 0 1-4.275 1.191 8.04 8.04 0 0 0 4.412 1.305",
    clipRule: "evenodd"
  })));
};
export default SvgTwitterinline;